module.exports = __webpack_public_path__ + "static/media/unionpay.4bbff7ad.png";